module.exports = __webpack_public_path__ + "img/yuan.7067dbcd.webp";